import { render, staticRenderFns } from "./basic-info-abroad.vue?vue&type=template&id=317ea907&"
import script from "./basic-info-abroad.vue?vue&type=script&lang=js&"
export * from "./basic-info-abroad.vue?vue&type=script&lang=js&"
import style0 from "./basic-info-abroad.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports